import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

import Style from '../../../styles/common';

const Icon = styled(FontAwesomeIcon)`
  font-size: ${props => props.size};
  margin-right: ${Style.SPACING.XS};
  transition: all 0.15s;
  
  &:hover {
    color: ${Style.color.SECONDARY_TEXT};
  }
  
  &:active {
    color: ${Style.color.defaultText};
  }
`;

function CloseIcon(props) {
  return (
    <Icon
      icon="times"
      onClick={props.onClick}
      size={props.size}
    />
  );
}

CloseIcon.propTypes = {
  onClick: PropTypes.func.isRequired,
  size: PropTypes.string
};

CloseIcon.defaultProps = {
  size: '1x',
};

export default CloseIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/CloseIcon/CloseIcon.js